import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.commons')
  .factory('ViewSettingsAPI', ViewSettingsAPI);

function ViewSettingsAPI(): BringozApi {
  return {
    base: `/viewSettings`,
    infiniteScroll: {
      address: `/viewSettings`,
      cmd: 'GET'
    },
    actions: {
      get: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      create: {
        address: '',
        cmd: 'PUT',
        updateable: false
      },
      update: {
        address: '{settingsId}',
        cmd: 'POST',
        updateable: false
      },
      delete: {
        address: '{settingsId}/private',
        cmd: 'DELETE',
        updateable: false
      }
    }
  }
}
